/**
 * Reorganizes Rebuy bundle widget layout by moving images
 * into their corresponding product blocks.
 * Also dynamically updates "Add to Cart" button text based on
 * the number of selected items in the bundle.
 * Only applies to widget ID 243142
 */
(function () {
  const WIDGET_ID = "243142";
  
  const waitForRebuyBundle = () => {
    const checkInterval = setInterval(() => {
      const targetWidget = document.getElementById(`rebuy-widget-${WIDGET_ID}`);
      const rebuyBundle = targetWidget ? targetWidget.querySelector(".rebuy-bundle") : null;

      if (rebuyBundle) {
        clearInterval(checkInterval);
        reorganizeBundleLayout();
      }
    }, 100);

    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkInterval), 10000);
  };

  const updateAddToCartButtonText = () => {
    const targetWidget = document.getElementById(`rebuy-widget-${WIDGET_ID}`);
    if (!targetWidget) return;
    
    const rebuyBundle = targetWidget.querySelector(".rebuy-bundle");
    if (!rebuyBundle) return;

    // Find all product blocks that are selected (not hidden/disabled)
    const productBlocks = rebuyBundle.querySelectorAll(".rebuy-product-block");
    
    // Count selected items (items that don't have 'disabled' or similar classes)
    let selectedCount = 0;
    productBlocks.forEach((block) => {
      // Check if the product block is active/selected
      // Rebuy typically adds classes or attributes to indicate selection state
      const checkbox = block.querySelector('input[type="checkbox"]');
      if (checkbox && checkbox.checked) {
        selectedCount++;
      } else if (!checkbox) {
        // If no checkbox, assume it's selected (some bundles don't have checkboxes)
        selectedCount++;
      }
    });

    // Find the Add to Cart button
    const addToCartButton = rebuyBundle.querySelector(".rebuy-bundle__actions-buttons .rebuy-button span");
    
    if (addToCartButton) {
      let buttonText = "Add to Cart";
      
      if (selectedCount > 2) {
        buttonText = `Add all ${selectedCount} to Cart`;
      } else if (selectedCount === 2) {
        buttonText = "Add both to Cart";
      } else if (selectedCount === 1) {
        buttonText = "Add to Cart";
      }
      
      addToCartButton.textContent = buttonText;
    }
  };

  const setupButtonTextListeners = () => {
    const targetWidget = document.getElementById(`rebuy-widget-${WIDGET_ID}`);
    if (!targetWidget) return;
    
    const rebuyBundle = targetWidget.querySelector(".rebuy-bundle");
    if (!rebuyBundle) return;

    // Listen for checkbox changes
    const checkboxes = rebuyBundle.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", updateAddToCartButtonText);
    });

    // Listen for clicks on product blocks (in case Rebuy uses click handlers instead of checkboxes)
    const productBlocks = rebuyBundle.querySelectorAll(".rebuy-product-block");
    productBlocks.forEach((block) => {
      block.addEventListener("click", () => {
        // Delay to let Rebuy's handlers run first
        setTimeout(updateAddToCartButtonText, 50);
      });
    });
  };

  const reorganizeBundleLayout = () => {
    const targetWidget = document.getElementById(`rebuy-widget-${WIDGET_ID}`);
    if (!targetWidget) return;
    
    const rebuyBundle = targetWidget.querySelector(".rebuy-bundle");
    if (!rebuyBundle) return;

    // Get all image containers
    const imageContainers = rebuyBundle.querySelectorAll(".rebuy-bundle__image");
    
    // Get all product blocks
    const productBlocks = rebuyBundle.querySelectorAll(".rebuy-product-block");

    if (!imageContainers.length || !productBlocks.length) return;

    // Match and move images into corresponding product blocks
    productBlocks.forEach((productBlock) => {
      // Skip if already has an image
      if (productBlock.querySelector(".rebuy-bundle__image-item")) {
        return;
      }
      
      // Extract product identifier classes from product block
      const productClasses = Array.from(productBlock.classList);
      
      // Find product ID class (most reliable identifier)
      const productIdClass = productClasses.find((cls) => cls.startsWith("product-id-"));

      if (!productIdClass) return;

      // Find the corresponding image container with the same product ID
      const matchingImageContainer = Array.from(imageContainers).find((container) => {
        return container.classList.contains(productIdClass);
      });

      if (matchingImageContainer) {
        // Find the image link inside the container
        const imageLink = matchingImageContainer.querySelector(".rebuy-bundle__image-item");
        // Find the plus sign divider
        const divider = matchingImageContainer.querySelector(".rebuy-bundle__image-divider");
        
        if (imageLink) {
          let insertedImageElement = null;
          
          // Convert <a> to <div> and preserve classes
          if (imageLink.tagName === "A") {
            const newDiv = document.createElement("div");
            newDiv.className = imageLink.className;
            
            // Clone all children from <a> to <div>
            Array.from(imageLink.childNodes).forEach(child => {
              newDiv.appendChild(child.cloneNode(true));
            });
            
            // Add the divider with the plus sign inside the image element
            if (divider) {
              const clonedDivider = divider.cloneNode(true);
              newDiv.appendChild(clonedDivider);
            }
            
            // Insert the new div at the beginning of the product block
            productBlock.insertBefore(newDiv, productBlock.firstChild);
            insertedImageElement = newDiv;
          } else {
            // If it's already not a link, just clone it
            const clonedImage = imageLink.cloneNode(true);
            
            // Add the divider with the plus sign inside the image element
            if (divider) {
              const clonedDivider = divider.cloneNode(true);
              clonedImage.appendChild(clonedDivider);
            }
            
            productBlock.insertBefore(clonedImage, productBlock.firstChild);
            insertedImageElement = clonedImage;
          }
        }
      }
    });
    
    // Hide the original images container since we've moved everything
    const imagesContainer = rebuyBundle.querySelector(".rebuy-bundle__images");
    if (imagesContainer) {
      imagesContainer.style.display = "none";
    }

    // Update button text after reorganizing
    updateAddToCartButtonText();
    
    // Set up event listeners for checkbox changes
    setupButtonTextListeners();
  };

  // Initialize when DOM is ready
  const init = () => {
    waitForRebuyBundle();
    
    // Also watch for any dynamic updates (e.g., if the widget reloads)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          const hasTargetWidget = Array.from(mutation.addedNodes).some((node) => {
            if (node.nodeType !== 1) return false;
            
            // Check if it's the target widget or contains it
            return (
              node.id === `rebuy-widget-${WIDGET_ID}` ||
              node.querySelector?.(`#rebuy-widget-${WIDGET_ID}`)
            );
          });
          
          if (hasTargetWidget) {
            setTimeout(reorganizeBundleLayout, 100);
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

